import type { TreeMapFilterByType } from "./tree-map.type";

export const TREE_MAP_DEFAULT_FILTER_BY_TYPE: TreeMapFilterByType = {
  organization: true,
  location: true,
  asset: true,
};
